/**
 * App-spezifische Handler für AufnahmePunktDocument.
 * Diese Handler implementieren die generischen Interfaces aus map/handlers/
 * und verbinden das Datenmodell mit den Library-Services.
 */

export { BohrpunktMapMarkerHandler } from './bohrpunkt-map-marker.handler';
export { BohrpunktGeoJsonHandler } from './bohrpunkt-geojson.handler';
export { BohrpunktWmsFieldMappingHandler } from './bohrpunkt-wms-field-mapping.handler';
export { BohrpunktGpkgAutoStyleHandler } from './bohrpunkt-gpkg-auto-style.handler';
export { BohrpunktProjectAssignmentHandler } from './bohrpunkt-project-assignment.handler';
export { BohrpunktDataLifecycleHandler } from './bohrpunkt-data-lifecycle.handler';
